export const LOAD_ID = 'load_id';

export const SHIFT_ID = 'shift_id';
